import { endpoints } from "../../config/endpoints";
import { axiosPrivateFetch } from "../../services/fetch-service";

const getServiceReports = ({ page, rows }) => {
   const url = endpoints.serviceReports;
   const options = { params: { page, rows } };
   return axiosPrivateFetch.get(url, options);
};

const getServiceReport = (id) => {
   return axiosPrivateFetch.get(`${endpoints.serviceReports}/${id}`);
};

const submitServiceReport = async ({ service, editOrCreate }) => {
   const options =
      editOrCreate === "edit"
         ? {
              method: "PUT",
              data: service,
           }
         : { method: "POST", data: service };

   const url = editOrCreate === "edit" ? `${endpoints.serviceReports}/${service.id}` : endpoints.serviceReports;

   return axiosPrivateFetch(url, options);
};

const getReportComments = (reportId) => {
   const url = `${endpoints.serviceReports}/${reportId}/comments`;

   return axiosPrivateFetch.get(url);
};

const submitReportComment = async ({ id, reportId, comment, editOrCreate }) => {
   const options =
      editOrCreate === "edit"
         ? {
              method: "PUT",
              data: comment,
           }
         : { method: "POST", data: comment };

   const url =
      editOrCreate === "edit"
         ? `${endpoints.serviceReports}/${reportId}/comments/${id}`
         : `${endpoints.serviceReports}/${reportId}/comments`;

   return axiosPrivateFetch(url, options);
};

const deleteReportComment = async ({ id, reportId }) => {
   const url = `${endpoints.serviceReports}/${reportId}/comments/${id}`;

   return axiosPrivateFetch(url, { method: "DELETE" });
};

const serviceReportService = {
   getServiceReports,
   getServiceReport,
   submitServiceReport,
   getReportComments,
   submitReportComment,
   deleteReportComment,
};

export { serviceReportService };
